import { useSelector } from "react-redux";
import { useLocation } from "react-router";

/**
 * Marketing CTAs: guests go to signup with return path; signed-in users go home.
 */
export function useSignupCta() {
  const location = useLocation();
  const { isAuthenticated } = useSelector((s) => s.infoboxx_consumer);
  const currentPath = `${location.pathname}${location.search || ""}`;
  const onSignupPage = location.pathname === "/signup" || location.pathname === "/signin";

  return {
    to: isAuthenticated ? "/" : "/signup",
    signupLinkState:
      !isAuthenticated && !onSignupPage ? { postAuthRedirect: currentPath } : undefined,
    isAuthenticated,
  };
}
